module.exports = __webpack_public_path__ + "c38c3643ec80701e1c86509acbaa66e4.pdf";